module.exports = __webpack_public_path__ + "static/img/subtree.99d3bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/subtree.png
// module id = btiC
// module chunks = 1